import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitApplication } from '../../../actions/applications';
import { getRoute, getSession, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import { getShoppingCart } from '../../../actions/shopping_carts';
import useValidateRoute from '../../../hooks/useValidateRoute';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Loading from '../../shared/Loading';
import Error from '../../shared/Error';

export default function ProcessApplication() {
  const dispatch = useDispatch();

  const isLoading = useSelector(state => state.sessions.get('loading'));
  const session = useSelector(state => state.sessions.get('session'));
  const application = useSessionEntity('application');
  const cart = useSessionEntity('shopping_cart');

  const isValidRoute = useValidateRoute({ apply: true, company: true });

  useEffect(() => {
    if (isValidRoute && application) {
      dispatch(loading(true));
      dispatch(asyncActions(
        submitApplication(application),
        getSession({
          cart: false,
          merchant: false,
          prequal: false,
          user: false
        }),
        getRoute(),
        cart && getShoppingCart(session.depId('shopping_cart'))
      ))
      .then(() => dispatch(loading(false)));
    }
  }, []);

  return (
    <div id="content">
      <div className="has-text-centered mb-5">
        <div className="is-size-4 has-text-weight-semibold">We're processing your information</div>
        <div className="has-text-weight-semibold text-green-highlight">Remember: applying will <u>not</u> affect your personal credit</div>
      </div>

      <Error />

      <Loading 
        active={isLoading} 
        css="process-app-loader is-size-1 mt-5 mb-5" />
    </div>
  )
}
